var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _g, _path2, _path3, _path4, _path5, _path6, _g2, _rect2, _rect3, _rect4, _rect5, _path7, _path8, _path9, _g3, _rect6, _rect7, _rect8, _path10, _g4, _rect9, _path11, _g5, _g6, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasskeySuccessIllustration = function SvgPasskeySuccessIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 600,
    viewBox: "0 0 468 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkeySuccessIllustration_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 600,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 169c0-40.869 33.131-74 74-74h123c6.627 0 12 5.373 12 12v359c0 22.091-17.909 40-40 40H162a6 6 0 0 1-6-6V169Z",
    fill: "#3910ED",
    fillOpacity: 0.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 392,
    r: 2,
    fill: "#414141"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 372,
    r: 2,
    fill: "#414141"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 412,
    r: 2,
    fill: "#414141"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 432,
    r: 2,
    fill: "#414141"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#passkeySuccessIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.002,
    y: 420,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.629 431.388c3.403-.15 7.834.503 11.976 3.695a.712.712 0 0 1-.869 1.13c-3.819-2.943-7.897-3.548-11.035-3.412-1.57.068-2.903.321-3.849.56-.472.119-.848.235-1.107.321a8.53 8.53 0 0 0-.301.106l-.08.029-.022.009a.02.02 0 0 1-.006.002l-.002.002a.713.713 0 0 1-.544-1.318c.057-.024 2.438-.975 5.839-1.124Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 0.285
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.795 434.773c5.24.62 9.744 3.794 12.377 8.702a.713.713 0 1 1-1.257.674c-2.413-4.499-6.528-7.404-11.288-7.96-4.495-.532-8.829 1.134-11.893 4.572a.714.714 0 0 1-1.006.059h-.001a.714.714 0 0 1-.058-1.006c3.376-3.789 8.161-5.628 13.126-5.041Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 0.285
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.496 440.37c3.138-2.058 6.769-2.644 10.221-1.645 3.365.975 6.185 3.413 7.788 6.711l.151.322.003.007c.049.126.531 1.425.703 2.992.171 1.56.039 3.432-1.193 4.659-1.273 1.269-3.152 1.75-4.787 1.219-1.57-.511-2.627-1.827-2.91-3.593-.226-1.409-.464-2.391-.88-3.057-.405-.65-.988-1.009-1.949-1.149a4.006 4.006 0 0 0-1.876.315c-.659.293-1.214.802-1.335 1.637a.906.906 0 0 1-.016.075c-.036.141-.465 1.93.082 4.086.546 2.149 2.066 4.677 5.956 6.302a.714.714 0 0 1-.465 1.345l-.085-.029c-4.29-1.792-6.051-4.644-6.716-7.13-.661-2.477-.233-4.579-.162-4.889.2-1.299.995-2.125 1.937-2.602.939-.476 2.03-.608 2.85-.525l.008.001c1.505.218 2.421.902 3.009 1.876.582.963.837 2.202 1.048 3.518.202 1.257.896 2.122 1.945 2.463 1.127.365 2.438.027 3.341-.873.432-.431.668-1.017.772-1.667.104-.65.076-1.356-.01-2.012-.174-1.313-.579-2.405-.586-2.424v-.001c-1.389-3.046-3.954-5.319-7.02-6.207-3.041-.881-6.253-.362-9.044 1.468-2.699 1.77-3.674 4.703-3.967 7.228-.291 2.507.094 4.583.105 4.643l.013.144a.712.712 0 0 1-1.411.131c-.038-.193-.471-2.503-.121-5.272.349-2.77 1.484-6.023 4.601-8.067Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 0.285
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.828 448.879a.707.707 0 0 1 .817-.382.715.715 0 0 1 .517.866c-.425 1.684.096 3.598 1.414 5.117 1.423 1.642 3.426 2.493 5.353 2.29a.714.714 0 0 1 .754.493l.029.141a.713.713 0 0 1-.634.784 6.9 6.9 0 0 1-1.717-.036c-1.814-.262-3.552-1.227-4.863-2.738-1.612-1.861-2.261-4.252-1.719-6.4l.049-.135Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 0.285
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.817 442.046c3.74.541 6.574 3.799 6.591 7.579l.005.963a.713.713 0 0 1-.71.715.707.707 0 0 1-.716-.708l-.005-.963c-.014-3.079-2.323-5.734-5.369-6.175l-.348-.051a6.867 6.867 0 0 0-5.804 1.879 6.873 6.873 0 0 0-2.06 5.749c.323 2.855 1.45 5.145 3.344 6.819a.713.713 0 0 1 .063 1.006v.001a.715.715 0 0 1-1.007.061c-2.171-1.919-3.454-4.523-3.816-7.727a8.289 8.289 0 0 1 2.484-6.932 8.286 8.286 0 0 1 7-2.267l.348.051Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 0.285
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#passkeySuccessIllustration_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 397,
    width: 195,
    height: 231,
    rx: 8,
    transform: "rotate(-90 190 397)",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.404,
    y: 396.596,
    width: 194.192,
    height: 230.192,
    rx: 7.596,
    transform: "rotate(-90 190.404 396.596)",
    stroke: "url(#passkeySuccessIllustration_svg__d)",
    strokeOpacity: 0.8,
    strokeWidth: 0.808
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 212,
    width: 211,
    height: 175,
    rx: 8,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 337,
    width: 149,
    height: 26,
    rx: 5.58,
    fill: "#3910ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 282,
    y: 279,
    width: 48.3,
    height: 6.9,
    rx: 3.232,
    fill: "#DFE5EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 295.1,
    width: 138,
    height: 6.9,
    rx: 3.232,
    fill: "#F5F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.568 189.084a3.695 3.695 0 0 1 3.695-3.694h73.896a3.694 3.694 0 0 1 3.694 3.694v59.117a3.695 3.695 0 0 1-3.694 3.695h-73.896a3.696 3.696 0 0 1-3.695-3.695v-59.117Z",
    fill: "#A6FFD7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.417 218.472c.015-11.089 9.003-20.071 20.081-20.056 11.079.014 20.044 9.021 20.029 20.111-.015 11.089-9.004 20.071-20.083 20.056-11.078-.015-20.042-9.021-20.027-20.111Z",
    stroke: "#3910ED",
    strokeWidth: 3.218
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m303.382 222.963 10.765-10.649a1.094 1.094 0 0 1 1.535 0c.424.42.424 1.099 0 1.519l-11.596 11.471a1 1 0 0 1-1.407 0l-4.361-4.314a1.065 1.065 0 0 1 0-1.518 1.093 1.093 0 0 1 1.535 0l3.529 3.491Z",
    fill: "#3910ED",
    stroke: "#3910ED",
    strokeWidth: 1.546
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#passkeySuccessIllustration_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 246,
    width: 83,
    height: 148,
    rx: 8,
    transform: "rotate(-90 79 246)",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.404,
    y: 245.596,
    width: 82.192,
    height: 147.192,
    rx: 7.596,
    transform: "rotate(-90 79.404 245.596)",
    stroke: "url(#passkeySuccessIllustration_svg__f)",
    strokeWidth: 0.808
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 171,
    width: 132,
    height: 67,
    rx: 4,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 181,
    width: 21,
    height: 3,
    rx: 1.405,
    fill: "#CFD1DC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 188,
    width: 60,
    height: 3,
    rx: 1.405,
    fill: "#ECEFF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "passkeySuccessIllustration_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 181,
    width: 26,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119 181H93v10h26v-10Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#passkeySuccessIllustration_svg__g)",
    fill: "#20303C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.002 181h-1.436c-.399 0-.771.196-.995.524l-1.92 2.814a.13.13 0 0 1-.214 0l-1.92-2.814a1.205 1.205 0 0 0-.995-.524h-1.436l3.421 5.014-3.402 4.986h1.436c.398 0 .771-.196.995-.524l1.901-2.787a.13.13 0 0 1 .214 0l1.901 2.787c.224.328.597.524.995.524h1.436l-3.402-4.986 3.421-5.014ZM107.131 182.022V191h.686c.569 0 1.03-.458 1.03-1.023V181h-.686c-.569 0-1.03.458-1.03 1.022ZM105.87 181h-.61c-.673 0-1.256.462-1.405 1.113l-1.366 5.968-1.196-5.571a1.908 1.908 0 0 0-2.373-1.425c-.693.19-1.207.772-1.357 1.47l-1.184 5.519-1.364-5.96A1.438 1.438 0 0 0 93.61 181H93l2.29 10h.867c.787 0 1.467-.547 1.631-1.312l1.463-6.823a.187.187 0 0 1 .182-.146c.087 0 .163.062.181.146l1.465 6.823A1.665 1.665 0 0 0 102.71 191h.871l2.289-10Z"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 93.367,
    y: 203.367,
    width: 118.267,
    height: 21.267,
    rx: 2.567,
    stroke: "#D6E6FE",
    strokeWidth: 0.733
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8CAFF",
    strokeWidth: 0.733,
    d: "M101.367 207v14"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#passkeySuccessIllustration_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.721 233.151h74.925a4.473 4.473 0 0 1 4.473 4.473v20.128a4.474 4.474 0 0 1-4.473 4.474h-88.344a4.474 4.474 0 0 1-4.474-4.474v-20.128a4.473 4.473 0 0 1 4.474-4.473h6.709l3.354-3.356 3.356 3.356Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkeySuccessIllustration_svg__i)",
    fill: "#000624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.043 252.72h-3.914a.56.56 0 0 1-.559-.559v-1.118c0-1.434.9-2.658 2.166-3.138a2.236 2.236 0 1 1 2.379 0 6.218 6.218 0 0 1-.631.342v-.655a1.677 1.677 0 1 0-1.118 0v.711a2.797 2.797 0 0 0-2.237 2.74v1.118h3.914v.559ZM123.56 249.086a.28.28 0 1 1-.56-.002.28.28 0 0 1 .56.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28 248.247a1.118 1.118 0 0 0-.671 2.013l.112.084v2.296l.554.528.484-.483-.559-.839.559-.559-.289-.434a.28.28 0 0 1 .148-.421 1.12 1.12 0 0 0-.338-2.185Zm-1.677 1.118a1.677 1.677 0 1 1 2.516 1.453l.359.54-.559.559.559.839-1.193 1.193-1.123-1.069v-2.264a1.675 1.675 0 0 1-.559-1.251Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.224 244.974v3.799c0 .825-.217 1.468-.649 1.93-.433.456-1.03.684-1.79.684-.761 0-1.36-.228-1.799-.684-.433-.462-.649-1.105-.649-1.93v-3.799h.903v3.799c0 .567.135 1.009.404 1.325.275.316.655.473 1.141.473.485 0 .862-.157 1.131-.473.275-.316.413-.758.413-1.325v-3.799h.895Zm.978 5.615.492-.57c.187.204.4.368.64.491.246.123.521.184.825.184.292 0 .526-.061.702-.184a.587.587 0 0 0 .263-.491.461.461 0 0 0-.228-.404c-.152-.099-.418-.178-.798-.237-.615-.093-1.053-.24-1.317-.439-.257-.204-.386-.482-.386-.833 0-.275.073-.512.22-.711.146-.205.348-.362.605-.474.263-.117.565-.175.904-.175a2.372 2.372 0 0 1 1.816.798l-.509.571a1.816 1.816 0 0 0-.57-.492 1.417 1.417 0 0 0-.728-.184c-.258 0-.468.059-.632.176a.507.507 0 0 0-.246.438c0 .147.067.261.202.342.14.082.398.153.772.211.644.094 1.097.252 1.36.474.269.216.404.52.404.912 0 .275-.079.518-.237.729-.152.21-.369.374-.649.491a2.428 2.428 0 0 1-.957.175c-.415 0-.787-.07-1.114-.21a2.48 2.48 0 0 1-.834-.588Zm8.213-.623.517.553c-.228.286-.5.503-.816.649-.31.146-.649.219-1.017.219-.457 0-.857-.099-1.202-.298a2.12 2.12 0 0 1-.799-.825 2.433 2.433 0 0 1-.289-1.193c0-.444.093-.842.28-1.193.187-.351.445-.626.772-.825a2.044 2.044 0 0 1 1.106-.307c.398 0 .749.099 1.053.298.304.193.541.462.711.807.175.346.263.74.263 1.185v.316h-3.264c.052.398.202.716.447.956.246.234.568.351.965.351.527 0 .951-.231 1.273-.693Zm-1.457-2.492c-.327 0-.602.114-.825.342-.216.223-.348.524-.394.904h2.369c-.035-.386-.155-.69-.36-.912-.199-.223-.462-.334-.79-.334Zm6.394 3.913c-.31 0-.585-.058-.824-.175a1.417 1.417 0 0 1-.562-.5 1.352 1.352 0 0 1-.193-.72c0-.45.172-.801.518-1.053.345-.257.816-.386 1.412-.386h1.097c0-.333-.102-.599-.307-.798-.199-.199-.48-.298-.842-.298-.457 0-.866.193-1.229.579l-.509-.544c.515-.497 1.118-.746 1.808-.746.386 0 .719.076 1 .228.287.146.509.354.667.623.158.263.237.573.237.93v2.72h-.799v-.57a1.65 1.65 0 0 1-.623.526 1.91 1.91 0 0 1-.851.184Zm.176-.684c.298 0 .558-.076.781-.228a1.32 1.32 0 0 0 .491-.623v-.676h-1.018c-.351 0-.626.071-.825.211a.654.654 0 0 0-.289.57c0 .223.076.404.228.544.158.135.369.202.632.202Zm6.259 2.246h-.877v-6.063h.868v.746c.141-.269.343-.482.606-.64.269-.164.57-.246.904-.246.391 0 .74.099 1.044.298.31.199.552.474.728.825.181.351.272.752.272 1.202 0 .45-.094.851-.281 1.202-.181.351-.43.626-.746.825a1.95 1.95 0 0 1-1.053.289c-.327 0-.617-.067-.868-.201a1.578 1.578 0 0 1-.597-.544v2.307Zm0-3.799v.562c.094.275.255.5.483.675.234.17.5.255.798.255.269 0 .503-.068.702-.202.199-.135.354-.319.465-.553.117-.24.176-.512.176-.816 0-.462-.117-.839-.351-1.132a1.133 1.133 0 0 0-.939-.447c-.258 0-.489.07-.693.21a1.454 1.454 0 0 0-.474.588 2.071 2.071 0 0 0-.167.86Zm5.878 2.237c-.31 0-.585-.058-.824-.175a1.417 1.417 0 0 1-.562-.5 1.352 1.352 0 0 1-.193-.72c0-.45.172-.801.518-1.053.345-.257.816-.386 1.412-.386h1.097c0-.333-.102-.599-.307-.798-.199-.199-.48-.298-.842-.298-.457 0-.866.193-1.229.579l-.509-.544c.515-.497 1.118-.746 1.808-.746.386 0 .719.076 1 .228.287.146.509.354.667.623.158.263.237.573.237.93v2.72h-.799v-.57a1.65 1.65 0 0 1-.623.526 1.91 1.91 0 0 1-.851.184Zm.176-.684c.298 0 .558-.076.781-.228a1.32 1.32 0 0 0 .491-.623v-.676h-1.018c-.351 0-.626.071-.825.211a.654.654 0 0 0-.289.57c0 .223.076.404.228.544.158.135.369.202.632.202Zm2.946-.114.491-.57c.188.204.401.368.641.491.246.123.52.184.825.184.292 0 .526-.061.702-.184a.587.587 0 0 0 .263-.491.461.461 0 0 0-.228-.404c-.152-.099-.419-.178-.799-.237-.614-.093-1.053-.24-1.316-.439-.257-.204-.386-.482-.386-.833 0-.275.073-.512.219-.711.147-.205.348-.362.606-.474.263-.117.564-.175.904-.175a2.364 2.364 0 0 1 1.816.798l-.509.571a1.816 1.816 0 0 0-.57-.492 1.42 1.42 0 0 0-.729-.184c-.257 0-.468.059-.631.176a.507.507 0 0 0-.246.438c0 .147.067.261.202.342.14.082.397.153.772.211.643.094 1.097.252 1.36.474.269.216.403.52.403.912 0 .275-.079.518-.236.729-.153.21-.369.374-.65.491a2.423 2.423 0 0 1-.956.175c-.415 0-.787-.07-1.114-.21a2.48 2.48 0 0 1-.834-.588Zm4.396 0 .491-.57c.187.204.401.368.641.491.245.123.52.184.824.184.293 0 .527-.061.702-.184a.584.584 0 0 0 .263-.491.461.461 0 0 0-.228-.404c-.152-.099-.418-.178-.798-.237-.614-.093-1.053-.24-1.316-.439-.258-.204-.386-.482-.386-.833 0-.275.073-.512.219-.711.146-.205.348-.362.605-.474a2.21 2.21 0 0 1 .904-.175 2.369 2.369 0 0 1 1.816.798l-.508.571a1.809 1.809 0 0 0-.571-.492 1.414 1.414 0 0 0-.728-.184c-.257 0-.468.059-.632.176a.506.506 0 0 0-.245.438.38.38 0 0 0 .201.342c.141.082.398.153.772.211.644.094 1.097.252 1.36.474.27.216.404.52.404.912 0 .275-.079.518-.237.729-.152.21-.368.374-.649.491a2.427 2.427 0 0 1-.956.175c-.416 0-.787-.07-1.115-.21a2.477 2.477 0 0 1-.833-.588Zm5.738.658h-.878v-6.317h.878v3.913l1.93-1.957h1.097l-2.124 2.097 2.37 2.264h-1.176l-2.097-2.044v2.044Zm7.033-1.281.517.553c-.228.286-.5.503-.816.649-.31.146-.649.219-1.018.219-.456 0-.857-.099-1.202-.298a2.124 2.124 0 0 1-.798-.825 2.433 2.433 0 0 1-.29-1.193c0-.444.094-.842.281-1.193.187-.351.445-.626.772-.825a2.042 2.042 0 0 1 1.106-.307c.398 0 .749.099 1.053.298.304.193.541.462.71.807.176.346.264.74.264 1.185v.316h-3.264c.052.398.201.716.447.956.246.234.568.351.965.351.527 0 .951-.231 1.273-.693Zm-1.457-2.492c-.328 0-.602.114-.825.342-.216.223-.348.524-.395.904h2.369c-.035-.386-.155-.69-.359-.912-.199-.223-.462-.334-.79-.334Zm5.999-.588h.886l-2.018 5.01c-.134.34-.307.6-.517.781-.205.182-.506.272-.904.272h-.544v-.737h.518c.199 0 .351-.044.456-.131a.86.86 0 0 0 .246-.395l.158-.421-1.764-4.379h.921l1.272 3.449 1.29-3.449Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "passkeySuccessIllustration_svg__b",
    x: 328.002,
    y: 416,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6852_120619",
    result: "effect2_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_6852_120619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "passkeySuccessIllustration_svg__c",
    x: 149.614,
    y: 175.076,
    width: 311.773,
    height: 275.773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.193
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.202462 0 0 0 0 0.22876 0 0 0 0 0.817834 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6852_120619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "passkeySuccessIllustration_svg__e",
    x: 38.614,
    y: 136.076,
    width: 228.773,
    height: 163.773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.193
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.202462 0 0 0 0 0.22876 0 0 0 0 0.817834 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6852_120619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "passkeySuccessIllustration_svg__h",
    x: 94.764,
    y: 219.731,
    width: 117.42,
    height: 52.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.355
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.677
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.032
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 0 0.239216 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6852_120619",
    result: "effect2_dropShadow_6852_120619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_6852_120619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passkeySuccessIllustration_svg__d",
    x1: 385,
    y1: 628,
    x2: 273.681,
    y2: 663.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passkeySuccessIllustration_svg__f",
    x1: 79,
    y1: 252.5,
    x2: 120.683,
    y2: 242.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "passkeySuccessIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 600,
    rx: 20,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "passkeySuccessIllustration_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(113.775 241.538)",
    d: "M0 0h13.419v13.419H0z"
  })))));
};
export default SvgPasskeySuccessIllustration;